import type { ProjectsResponse } from '../../../../../api/projects-client/projects-client.type';
import { FiltersList } from './filters-list';

type Props = {
  teams: ProjectsResponse[];
  selectedTeams: ProjectsResponse[];
  onSelectTeams: (teams: ProjectsResponse[]) => void;
};

export const FiltersListTeams = ({ teams, selectedTeams, onSelectTeams }: Props) => {
  return (
    <FiltersList
      items={teams}
      selectedItems={selectedTeams}
      onSelectItems={onSelectTeams}
      getItemName={(team) => team.name}
    />
  );
};
